module.exports = __webpack_public_path__ + "media/media/about/partner-1-00ce7bc537a2011da00006d6a7d77aa9.png";